<template>
  <div class="bantuan-footer">
    <div class="bantuan-footer__content">
      <img
        :src="$publicUrl('images/kartu-prakerja/img_small_question.webp')"
        width="24"
        height="24"
        alt="img_small_question"
        loading="lazy"
      />
      <BlTextAv variation="body-14" weight="bold" class="flex items-center">
        Ada kendala terkait Prakerja?
        <BlButtonAv variation="naked" class="p-0" size="small" @click="openSheet">Klik disini</BlButtonAv>
      </BlTextAv>
    </div>
    <BlSheetMv :active.sync="isSheetOpen" title="Bantuan" auto-height>
      <div slot="content">
        <div class="bantuan-footer__card">
          <BlTextAv variation="caption-12" weight="bold">Kontak Prakerja</BlTextAv>
          <div class="flex items-center mt-8 gap-2">
            <img src="https://s4.bukalapak.com/attachment/971062/ico_whatsapp_minor.png" width="20" height="20" />
            <a class="no-underline" href="https://api.whatsapp.com/send/?phone=6287701503001" rel="nofollow">
              <BlTextAv variation="body-14">087701503001</BlTextAv>
            </a>
          </div>
          <div class="flex items-center mt-8 gap-2">
            <img src="https://s0.bukalapak.com/attachment/581062/ico_document_minor.png" width="20" height="20" />
            <a class="no-underline" href="https://bantuan.prakerja.go.id/hc/id/requests/new" rel="nofollow">
              <BlTextAv variation="body-14">Formulir pengaduan</BlTextAv>
            </a>
          </div>
        </div>
        <div v-if="isShowMerchantContact" class="bantuan-footer__card mt-8">
          <BlTextAv variation="caption-12" weight="bold" data-testid="merchant-name">Kontak {{ merchantName }}</BlTextAv>
          <div v-if="merchantPhone" class="flex items-center mt-8 gap-2">
            <img src="https://s2.bukalapak.com/attachment/281062/ico_phone.png" width="20" height="20" />
            <a class="no-underline" :href="`tel:${merchantPhone}`" rel="nofollow">
              <BlTextAv variation="body-14" data-testid="merchant-phone">{{ merchantPhone }}</BlTextAv>
            </a>
          </div>
          <div v-if="merchantEmail" class="flex items-center mt-8 gap-2">
            <img src="https://s3.bukalapak.com/attachment/881062/ico_email_minor.png" width="20" height="20" />
            <a class="no-underline" :href="`mailto:${merchantEmail}`" rel="nofollow">
              <BlTextAv variation="body-14" data-testid="merchant-email">{{ merchantEmail }}</BlTextAv>
            </a>
          </div>
        </div>
      </div>
    </BlSheetMv>
  </div>
</template>

<script>
import {BlTextAv, BlButtonAv, BlSheetMv} from '@bukalapak/bazaar-mweb-latest';

export default {
  name: 'BantuanFooter',
  components: {
    BlTextAv,
    BlButtonAv,
    BlSheetMv,
  },
  props: {
    merchantName: {
      type: String,
      default: '',
    },
    merchantEmail: {
      type: String,
      default: '',
    },
    merchantPhone: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isSheetOpen: false,
    };
  },
  computed: {
    isShowMerchantContact() {
      return this.merchantName && (this.merchantEmail || this.merchantPhone);
    },
  },
  methods: {
    openSheet() {
      this.isSheetOpen = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.bantuan-footer {
  padding: 16px;
  &__content {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  &__card {
    border: 1px solid #ebebeb;
    padding: 12px;
    margin: 12px;
    border-radius: 12px;
  }
  &::v-deep {
    .bl-sheet {
      margin: auto;
      max-width: 480px;
    }
    .bl-sheet__box {
      height: auto !important;
    }
    .bl-sheet__nav-bar {
      display: flex;
    }
  }
}
</style>
